import { LegacyStack } from '@shopify/polaris';
import { useState } from 'react';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { deleteDeposit, depositEdit } from '../../../services/depositsService';
import DropdownButton from '../Common/DropdownButton';
import EditDepositModal from './EditDepositModal';
import { filterPermissionsMenu } from '../../../services/permissionsService';
import { PDFModal } from '../Modals/PDFModal';

const ViewDepositPrimaryActions = ({ id, returnUrl, canDelete, isOnlyGroup, onUpdateDeposit }) => {
  const history = useHistory();
  const [, dispatchToast] = useContext(ToastContext);

  const [activeEditModal, setActiveEditModal] = useState(false);
  const [activePDFModal, setActivePDFModal] = useState(false);
  const [queryPDF, setQueryPDF] = useState({
    depositId: id,
  });

  const handleDeleteDeposit = (id) =>
    window.confirm('¿Estás seguro de que quieres eliminar el depósito?') &&
    deleteDeposit(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const handleEditDeposit = (values) => {
    depositEdit(id, values)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: { message: 'Datos cambiados' } });
        setActiveEditModal(false);
        onUpdateDeposit();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  const handlePDFExport = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //Transform urlParams to object queryPDF
    const q = {};
    for (const [key, value] of urlParams) {
      q[key] = value;
    }
    delete q['r'];

    setQueryPDF({ ...queryPDF, ...q });

    setActivePDFModal(true);
  };

  const dropdownItems = [
    {
      title: 'Movimientos',
      items: [
        !isOnlyGroup && {
          content: 'Ver traspasos',
          permissions: ['STOCK:READ'],
          url: `/transfers/?originId=${id}&destinationId=${id}&r=${window.btoa(
            window.location.pathname + window.location.search,
          )}`,
        },
        !isOnlyGroup && {
          content: 'Ver recepciones',
          permissions: ['DELIVERY:READ'],
          url: `/deliveries/?depositId=${id}&r=${window.btoa(window.location.pathname + window.location.search)}`,
        },
        !isOnlyGroup && {
          content: 'Ver inventarios',
          permissions: ['INVENTORY:READ'],
          url: `/inventories?deposits=${id}`,
        },
        !isOnlyGroup && {
          content: 'Ver pérdidas',
          permissions: ['DEPOSIT:READ'],
          url: `/deposits/${id}/losses`,
        },
      ].filter(Boolean),
    },
    {
      title: 'Propiedades',
      items: [
        { content: 'Editar', permissions: ['DEPOSIT:UPDATE'], onAction: () => setActiveEditModal(true) },
        {
          content: 'Eliminar',
          permissions: ['DEPOSIT:DELETE'],
          disabled: !canDelete,
          destructive: true,
          onAction: () => handleDeleteDeposit(id),
        },
      ],
    },
  ]
    .map((e) => ({ ...e, items: filterPermissionsMenu(e.items) }))
    .filter((e) => e.items.length);

  const dropdownItems2 = [
    {
      content: 'Exportar a PDF',
      disabled: false,
      onAction: handlePDFExport,
    },
    {
      content: 'Exportar a CSV',
      disabled: true,
    },
  ];
  return (
    <LegacyStack>
      <DropdownButton
        title={'Exportar'}
        items={dropdownItems2}
        buttonProps={{ disabled: dropdownItems2.reduce((acc, cur) => acc && cur.disabled, true) }}
      />
      {dropdownItems.length && <DropdownButton title={'Acciones'} items={dropdownItems} buttonProps={{}} />}
      <EditDepositModal
        active={activeEditModal}
        id={id}
        onSubmit={handleEditDeposit}
        onClose={() => setActiveEditModal(false)}
      />
      <PDFModal
        active={activePDFModal}
        onClose={() => setActivePDFModal(false)}
        domain={'deposits'}
        model={'stock'}
        query={queryPDF}
      />
    </LegacyStack>
  );
};

export default ViewDepositPrimaryActions;
